var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"mx-auto text-center",attrs:{"cols":"4"}},[_c('center',[_c('v-img',{attrs:{"width":"100","src":"/img/icons/fireworks.svg"}})],1),_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.description))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }